import { createResource } from 'react-resource-router/resources';

import localStorageFacade from '@townsquare/facade/local-storage';
import type { HomeResourceContext } from '@townsquare/router/types';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import { PROMPT_OVERRIDE_KEY } from './constants';
import { fetchThreads } from './transport';

export const threadsResource = createResource({
	getData: async (_routerContext, resourceContext) => {
		if (!isGateEnabled('townsquare_enable_threads')) {
			return null;
		}

		const context = resourceContext as HomeResourceContext;

		if (!context.collabContext?.rovoWorkspace) {
			throw new Error('Rovo workspace not found');
		}

		const response = await fetchThreads({
			userId: context.user.accountId,
			cloudId: context.collabContext.rovoWorkspace,
			promptOverride: isGateEnabled('townsquare_enable_threads_prompt_override')
				? localStorageFacade.getItem(PROMPT_OVERRIDE_KEY) ?? undefined
				: undefined,
		});

		if (!response.ok) {
			throw new Error(`Failed to fetch threads: (${response.status}) ${response.statusText} `);
		}

		return response.json();
	},
	getKey: (_routerContext, resourceContext) => {
		const context = resourceContext as HomeResourceContext;
		return `threads-key-${context.user.accountId}`;
	},
	type: 'THREADS',
});
